import React from 'react';
import { Link } from 'react-router-dom';

const variants = {
  primary:
    'bg-gradient-to-r from-slate-950 via-blue-700 to-teal-600 text-white shadow-lg shadow-blue-900/15 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-blue-900/20',
  secondary:
    'border border-slate-200 bg-white/90 text-slate-900 shadow-sm shadow-slate-900/5 hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50/50',
  color:
    'bg-gradient-to-r from-blue-600 via-teal-500 to-amber-400 text-white shadow-lg shadow-blue-900/15 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-teal-900/20',
  ghost:
    'text-slate-600 hover:bg-slate-100 hover:text-slate-950',
};

const sizes = {
  sm: 'h-9 px-3 text-sm',
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-base',
};

function Button({
  as: Component = 'button',
  to,
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}) {
  const classes = [
    'focus-ring inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition duration-200 disabled:cursor-not-allowed disabled:opacity-60',
    variants[variant],
    sizes[size],
    className,
  ].join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
}

export default Button;
